import React from 'react'
import {createFragmentContainer, graphql} from 'react-relay'
import BoardTemplateRow from "./BoardTemplateRow"
import PropTypes from 'prop-types'

const BoardTemplateRowList = ({list, onEdit, onDelete}) => {
  return (
    <React.Fragment>
      {list.map(item => <BoardTemplateRow key={item.__id} rowData={item} onEdit={onEdit} onDelete={onDelete}/>)}
    </React.Fragment>
  )
}

BoardTemplateRowList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default createFragmentContainer(BoardTemplateRowList, {
  list: graphql`
    fragment BoardTemplateRowList_list on BoardTemplate @relay(plural: true) {
      ...BoardTemplateRow_rowData
    }
  `,
})
